import * as Yup from 'yup'

export interface ICashCollectionModel {
  id?: string | number
  createdAt?: string | Date
  updatedAt?: string | Date

  searchText?: string           
  receiptNumber?: string        
  firstName: string             
  lastName?: string              
  transactionDate: string        
  dueDate?: string               
  cashAmount?: number            
  cashAmountCurrency?: string   
  cashboxRate?: number           
  branch?: string                
  operator?: string              
  description?: string           
}

export const initialCashCollection: ICashCollectionModel = {
  firstName: '',
  transactionDate: new Date().toISOString().slice(0, 10),
  cashboxRate: 1,
  cashAmountCurrency: 'TL',
}

export const cashCollectionValidation = Yup.object({
  firstName: Yup.string().required('Cari Ad zorunludur'),
  lastName: Yup.string().nullable(),
  receiptNumber: Yup.string().nullable(),
  searchText: Yup.string().nullable(),
  transactionDate: Yup.string().required('Tarih zorunludur'),
  dueDate: Yup.string().nullable(),
  cashAmount: Yup.number().typeError('Sayı giriniz').nullable(),
  cashAmountCurrency: Yup.string().nullable(),
  cashboxRate: Yup.number().typeError('Sayı giriniz').nullable(),
  branch: Yup.string().nullable(),
  operator: Yup.string().nullable(),
  description: Yup.string().nullable(),
})
